interface TooltipPayloadItem {
  name: string;
  value: unknown;
  color?: string;
}

interface ChartTooltipProps {
  active?: boolean;
  payload?: TooltipPayloadItem[];
  label?: string;
}

export function ChartTooltip({ active, payload, label }: ChartTooltipProps) {
  if (!active || !payload?.length) return null;

  return (
    <div
      style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius)',
        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
        padding: '6px 10px',
        fontSize: '12px',
        color: 'var(--color-text-primary)',
      }}
    >
      {label && (
        <p style={{ marginBottom: 4, color: 'var(--color-text-secondary)', fontWeight: 500 }}>
          {label}
        </p>
      )}
      {payload.map((item, i) => (
        <p key={i} style={{ color: item.color ?? 'var(--color-text-primary)', margin: '2px 0' }}>
          <span style={{ color: 'var(--color-text-secondary)' }}>{item.name}: </span>
          {String(item.value)}
        </p>
      ))}
    </div>
  );
}
